import { motion } from "framer-motion";

type GalleryItem = {
  url: string;
  title: string;
  tag: string;
};

const galleryItems: GalleryItem[] = [
  {
    url: "https://t4.ftcdn.net/jpg/06/35/44/45/360_F_635444578_CDFldlAX7gZprsu1ZCIs5vSlglSEP5wc.jpg",
    title: "Nutrition Drive",
    tag: "Hunger Support",
  },
  {
    url: "https://blogger.googleusercontent.com/img/a/AVvXsEjtzRsxNG67lj4SdApB6rfXakDDNsiyBxWw7IzArlXGxzezp0GVLON4kEsfmEe2ZGN9Dluas8U0fCnripKsJAcFvGE72Te6IE71NVtAdhNrd6Y1bmQZpGqWjfyMQKm76NOXz6xRSmaemVK669baSRd2Sd8z7w3nmYXtv-6RiRwL7EvMnZQsj9TZ0u8oQhw",
    title: "Rural Classroom",
    tag: "Education",
  },
  {
    url: "https://www.globalgiving.org/pfil/24366/pict_large.jpg",
    title: "Skill Training",
    tag: "Livelihood",
  },
  {
    url: "https://gumlet.assettype.com/down-to-earth%2Fimport%2Flibrary%2Flarge%2F2023-04-07%2F0.06064300_1680864686_health_expenditure-istock.jpg?w=480&auto=format%2Ccompress&fit=max",
    title: "Healthcare Camp",
    tag: "Medical",
  },
  {
    url: "https://aashritha.org/wp-content/uploads/2024/05/Untitled-design-17-1024x576.png",
    title: "Distribution",
    tag: "Charity",
  },
];

const ImageBox = ({
  item,
  heightClass,
}: {
  item: GalleryItem;
  heightClass: string;
}) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    viewport={{ once: true }}
    className={`relative group rounded-[1.5rem] overflow-hidden shadow-lg hover:shadow-2xl bg-slate-200 cursor-pointer w-full ${heightClass}`}
  >
    <img
      src={item.url}
      alt={`Sevaa Foundation NGO ${item.tag} initiative - ${item.title}`}
      loading="lazy"
      className="w-full h-full object-cover transition-transform duration-[1.5s] ease-out group-hover:scale-110"
    />

    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-end p-8 text-left">
      <div className="transform translate-y-8 group-hover:translate-y-0 transition-transform duration-500">
        <span className="bg-[#ffb000] text-black text-[10px] font-black px-3 py-1.5 rounded-full uppercase shadow-lg inline-block mb-3">
          {item.tag}
        </span>

        <h4 className="text-white text-xl md:text-2xl font-black uppercase leading-tight mb-2">
          {item.title}
        </h4>
      </div>
    </div>

    <div className="absolute inset-0 border-2 border-transparent group-hover:border-white/20 transition-all duration-500 rounded-[2.5rem] pointer-events-none"></div>
  </motion.div>
);

const Gallery = () => {
  return (
    <section aria-labelledby="gallery-heading" className="py-20 bg-slate-50 font-poppins overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
          <div className="max-w-xl text-left">
            <motion.span
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="text-orange-600 font-bold text-xs uppercase mb-3 block"
            >
              Moments of Change
            </motion.span>

            <h2 id="gallery-heading" className="text-4xl md:text-6xl font-black text-slate-900 leading-none">
              Visual <span className="text-[#0f766e]">Impact</span> Gallery
            </h2>
          </div>

          <button
            className="text-[#0f766e] font-bold text-sm uppercase flex items-center gap-2 group border-b-2 border-transparent hover:border-[#0f766e] transition-all pb-1"
            onClick={() => (window.location.href = "/photo-gallery")}
            aria-label="View all Sevaa Foundation NGO social work photos"
          >
            View All Photos
            <svg
              className="w-4 h-4 transform group-hover:translate-x-2 transition-transform"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                d="M17 8l4 4m0 0l-4 4m4-4H3"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Perfect Symmetric Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Left Column */}
          <div className="flex flex-col gap-6">
            <ImageBox
              item={galleryItems[0]}
              heightClass="h-[250px] md:h-[300px]"
            />
            <ImageBox
              item={galleryItems[1]}
              heightClass="h-[250px] md:h-[300px]"
            />
          </div>

          {/* Center Column */}
          <div className="flex flex-col">
            <ImageBox
              item={galleryItems[2]}
              heightClass="h-[520px] md:h-[624px]"
            />
          </div>

          {/* Right Column */}
          <div className="flex flex-col gap-6">
            <ImageBox
              item={galleryItems[3]}
              heightClass="h-[250px] md:h-[300px]"
            />
            <ImageBox
              item={galleryItems[4]}
              heightClass="h-[250px] md:h-[300px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;